import type { AdsAlertGroup } from "../types";

import { DisplayAdsAlert, type IDisplayAdsAlertProps } from "./DisplayAdsAlert";
import { SearchAdsAlert } from "./SearchAdsAlert";
import { ShoppingAdsAlert } from "./ShoppingAdsAlert";
import { SocialAdsAlert } from "./social/SocialAdsAlert";

type AdsAlertCardProps = Pick<IDisplayAdsAlertProps, "groupIndex"> & {
    country: number;
    favicon: string;
    group: AdsAlertGroup;
};

export const AdsAlertCard = ({ group, country, favicon, groupIndex }: AdsAlertCardProps) => {
    if (group.groupType === "Display") {
        return (
            <DisplayAdsAlert
                groupIndex={groupIndex}
                country={country}
                domain={group.domain}
                favicon={favicon}
                ads={group.ads}
                totalAdsCount={group.totalCount}
            />
        );
    }

    if (group.groupType === "Search") {
        return (
            <SearchAdsAlert
                country={country}
                favicon={favicon}
                group={group}
            />
        );
    }

    if (group.groupType === "Shopping") {
        return (
            <ShoppingAdsAlert
                country={country}
                favicon={favicon}
                group={group}
            />
        );
    }

    if (group.groupType === "Social") {
        return (
            <SocialAdsAlert
                favicon={favicon}
                group={group}
                groupIndex={groupIndex}
            />
        );
    }

    return null;
};
